export interface TokenizerConfig {
  separator: string | string[];
  trim?: boolean;
  filterEmpty?: boolean;
}

export class Tokenizer {
  private separators: string[];
  private trim: boolean;
  private filterEmpty: boolean;

  constructor(config: TokenizerConfig | string | string[] = ',') {
    // Handle shorthand constructor with just separator
    if (typeof config === 'string' || Array.isArray(config)) {
      this.separators = Array.isArray(config) ? config : [config];
      this.trim = true;
      this.filterEmpty = true;
    } else {
      // Handle full config object
      this.separators = Array.isArray(config.separator) ? config.separator : [config.separator];
      this.trim = config.trim ?? true;
      this.filterEmpty = config.filterEmpty ?? true;
    }
  }

  split(input?: string | null): string[] {
    if (!input) return [];

    let result = [input];

    // Split by each separator in sequence
    this.separators.forEach((sep) => {
      result = result.flatMap((item) => item.split(sep));
    });

    // Apply transformations
    if (this.trim) {
      result = result.map((s) => s.trim());
    }

    if (this.filterEmpty) {
      result = result.filter(Boolean);
    }

    return result;
  }

  join(tokens: string[]): string | null {
    // Use the first separator for joining
    const separator = this.separators[0];
    return tokens.join(separator);
  }
}
